import { GameVars } from "../../GameVars";
import { StartLayer } from "./StartLayer";
import { GameConstants } from "../../GameConstants";
import { SoundButtonContainer } from "../board-scene/gui/SoundButtonContainer";
import { MusicButtonContainer } from "../board-scene/gui/MusicButtonContainer";
import { DificultySelectionLayer } from "./DificultySelectionLayer";
import { AudioManager } from "../../AudioManager";

export class SplashScene extends Phaser.Scene {

    public static currentInstance: SplashScene;

    private startLayer: StartLayer;
    private difficultyLayer: DificultySelectionLayer;
    
    constructor() {

        super("SplashScene");
        
        SplashScene.currentInstance = this;
    }

    public create(): void {

        GameVars.currentScene = this;

        this.add.image(GameConstants.GAME_WIDTH / 2, GameConstants.GAME_HEIGHT / 2, "bg_2");

        this.startLayer = new StartLayer(this);
        this.add.existing(this.startLayer); 

        this.difficultyLayer = new DificultySelectionLayer(this);
        this.add.existing(this.difficultyLayer);

        this.add.image(180, 130, "texture_atlas_language", "logo");

        let topBarRight = this.add.image(0, 0, "texture_atlas_1", "top_bar_right");
        topBarRight.setOrigin(0);

        let soundButton = new SoundButtonContainer(this);
        soundButton.x = GameConstants.GAME_WIDTH - 110;
        soundButton.y = 43;
        this.add.existing(soundButton);

        let musicButton = new MusicButtonContainer(this);
        musicButton.x = GameConstants.GAME_WIDTH - 40;
        musicButton.y = 43;
        this.add.existing(musicButton);

        AudioManager.playMusic("soundtrack", 1);
    }

    public showDifficultyLayer(): void {

        this.startLayer.visible = false;
        this.difficultyLayer.visible = true;
    }

    public showStartLayer(): void {

        this.startLayer.visible = true;
        this.difficultyLayer.visible = false;
    }
}
